import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import Chip from '@mui/material/Chip';

interface CustomProductsCellProps {
    [key: string]: any;
    status: string;
    statuses: [green?: string | string[], yellow?: string | string[], red?: string | string[]];
}

const colorsPalette = {
    green: {
        bgColor: 'common.system.success.bg',
        color: 'common.system.success.text',
    },
    yellow: {
        bgColor: 'common.system.warn.bg',
        color: 'common.system.warn.text',
    },
    red: {
        bgColor: 'common.system.error.bg',
        color: 'common.system.warn.text',
    },
};

const defaultColor = {
    bgColor: 'common.grey4',
    color: 'common.black',
};

const TableStatus: React.FC<CustomProductsCellProps> = ({ status, statuses }) => {
    const chipsPalette = useMemo(() => {
        const label = status.toLowerCase();
        const index = statuses.findIndex((item) => {
            if (!item) return false;

            if (typeof item === 'string') {
                return item.toLowerCase() === label;
            } else {
                return item.some((el) => el.toLowerCase() === label);
            }
        });
        const palette = Object.values(colorsPalette)[index] || defaultColor;

        return { ...palette, label };
    }, [status, statuses]);

    if (!status) {
        return null;
    }

    return (
        <Box>
            <Chip
                label={chipsPalette.label}
                sx={{
                    height: '20px',
                    backgroundColor: chipsPalette.bgColor,
                    color: chipsPalette.color,
                }}
                style={{ margin: '2px' }}
            />
        </Box>
    );
};

export default TableStatus;
